/**
 * A reference reduced to its letters and digits in lower case — the form two spellings of one
 * number share ("LS-2026/09/1187" and "LS 2026 09 1187"). Delivery notes are matched to the
 * invoice that cites them in this form, on the server and wherever a client sets the two side by
 * side.
 *
 * @param value - The reference as printed.
 * @returns The comparable form, or null when nothing is left to compare.
 */
export function comparableReference(value: string | null | undefined) {
	const reduced = value?.toLowerCase().replace(/[^a-z0-9]/g, "") ?? "";
	return reduced || null;
}
